import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import { createProduct } from "../../../../apis/Product";
import { useNavigate } from "react-router-dom";
import NewProductDialog from "./NewProductDialog";
import { CalculationSetupDialog } from "./CalculationSetupDialog";

const ProductModal = ({ onClose, year, subgroupId, business, subgroups, assessmentType = "PCF" }) => {
  const [idBusiness, setIdBusiness] = useState("");
  const [status, setStatus] = useState(false);
  const navigate = useNavigate();
  const [pendingFormData, setPendingFormData] = useState(null);
  const [knownVariables, setKnownVariables] = useState([]);
  const createdAssessmentTypeRef = useRef(null);
  const createdBusinessRef = useRef(null);

  const chosenSubgroup = useMemo(
    () => subgroups?.find((s) => s.id === subgroupId) || { id: subgroupId, business },
    [subgroups, subgroupId, business]
  );

  const handleMove = useCallback(() => {
    const typeForNav = createdAssessmentTypeRef.current || assessmentType;
    const businessForNav = createdBusinessRef.current || chosenSubgroup?.business;
    const params = new URLSearchParams();
    if (businessForNav) params.append("business", businessForNav);
    params.append("year", year);
    if (typeForNav) params.append("assessment_type", typeForNav);
    navigate(`/product/${idBusiness}?${params.toString()}`, { replace: true });
  }, [navigate, idBusiness, chosenSubgroup, year, assessmentType]);

  useEffect(() => {
    if (status === true) handleMove();
  }, [status, handleMove]);

  const handleConfirmForm = (formData) => {
    setPendingFormData(formData);
  };

  const handleCreateProduct = useCallback(
    (payload) => {
      const assessment_type = payload.assessment_type || "PCF";
      createdAssessmentTypeRef.current = assessment_type;
      createdBusinessRef.current = payload.business;
      createProduct({
        name: payload.name,
        productNum: payload.productNum,
        variationCategories: payload.variationCategories || [],
        year: year,
        setStatus: setStatus,
        setIdBusiness: setIdBusiness,
        subgroupId: payload.subgroupId,
        business: payload.business,
        sector: payload.sector,
        functional_unit_num: payload.fuValue,
        functional_unit_unit: payload.fuUnit,
        functional_unit_desc: payload.variant,
        assessment_type,
      });
      setPendingFormData(null);
    },
    [year]
  );

  if (pendingFormData) {
    return (
      <CalculationSetupDialog
        formData={pendingFormData}
        year={year}
        chosenSubgroup={chosenSubgroup}
        onCreateProduct={handleCreateProduct}
        onClose={() => {
          setPendingFormData(null);
          onClose();
        }}
      />
    );
  }

  return (
    <NewProductDialog
      categories={[]}
      defaultCategoryId={subgroupId}
      defaultBusiness={business}
      knownVariables={knownVariables}
      onAddKnownVariable={(label) => {
        setKnownVariables((prev) => (prev.includes(label) ? prev : [...prev, label]));
      }}
      onConfirm={handleConfirmForm}
      onClose={onClose}
      subgroups={subgroups}
      year={year}
    />
  );
};

export default ProductModal;
